// İSG uzmanı portalı — kabuk ROTA sekmeleri (Admin/Ayarlar/Ziyaretçiler/Çalışma İzni Tipleri;
// S33 Slice 5, owner kararı — bkz. `docs/plans/S33-carbon-reskin.md` Slice 5 "the shells own
// the header").
//
// Paylaşılan `Tabs` primitifi (`packages/shared/src/ui/Tabs.tsx`, value/onValueChange,
// `<button>`) GERÇEK ROTA değiştiren sekmeler için KULLANILAMAZ — tıklaması yalnız yerel state
// değiştirir, navigate ETMEZ. Bu dosya `NavLink` + Carbon seçili-durum GÖRSELİNİ (`border-b-2
// border-b-primary`, `font-semibold` — renk TEK BAŞINA taşımaz) BİR KEZ genelleştirir; DÖRT
// kabuk (`AdminShell`/`SettingsShell`/`VisitorsShell`/`PermitTypesShell`) doğrudan tüketir,
// hiçbiri kendi NavLink kopyasını YAZMAZ. Eski `PermitCatalogTabs.tsx` (İş İzni Tipleri
// alanının kendi sekme dizisi) owner review B2 item 7'de `PermitTypesShell.tsx`'e taşınarak
// SİLİNDİ — dördüncü kabuk artık bu dosyanın DOĞRUDAN tüketicisi, ayrı bir sarmalayıcı dosyası
// YOK (diğer üç kabukla AYNI desen).
//
// App-local (`DetailLayout.tsx` emsali) — Carbon'a özgü bir stil TAŞIMIYOR (`carbon:` öneki YOK,
// web-expert'in KENDİ build'i zaten her zaman Carbon) ama yalnız bu app'in kabukları tüketecek;
// `packages/shared`'a taşınmaz.

import { NavLink } from 'react-router-dom';

export interface RouteTabItem {
  to: string;
  /** `NavLink`'in `end` prop'u — yalnız TAM eşleşmede aktif (kök sekme, ör. `/visitors`). */
  end?: boolean;
  label: string;
}

export function RouteTabs({ items, ariaLabel }: { items: RouteTabItem[]; ariaLabel: string }) {
  return (
    <nav
      className="flex h-10 items-center overflow-x-auto whitespace-nowrap border-b border-border [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden"
      aria-label={ariaLabel}
    >
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end}
          className={({ isActive }) =>
            [
              'inline-flex h-10 shrink-0 items-center border-0 border-b-2 px-4 text-sm font-medium transition-colors',
              isActive
                ? 'border-b-primary font-semibold text-fg'
                : 'border-b-transparent text-muted hover:border-b-border-strong hover:text-fg',
            ].join(' ')
          }
        >
          {item.label}
        </NavLink>
      ))}
    </nav>
  );
}
